
define(
	'Tavanoteam.ProductSchemaFix.ProductSchemaFix'
	, [
		'Backbone'
		, 'Utils'
		, 'jQuery'
		, 'underscore'
	]
	, function (
		Backbone
		, Utils
		, jQuery
		, _
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				// using the 'Layout' component we add a new child view inside the 'Header' existing view 
				// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
				// more documentation of the Extensibility API in
				// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html

				/** @type {LayoutComponent} */

				//Get Components
				var layout = container.getComponent('Layout'),
					pdp = container.getComponent('PDP'),
					environment = container.getComponent('Environment');

				//Get Configuration
				var getMarkupType = environment.getConfig("structureddatamarkup.type"),
					enableJSONLogs = environment.getConfig("TTProductSchema.enableLogs");

				//Validate if JSON-LD is being used
				if (getMarkupType == "JSON-LD") {

					pdp.cancelableOn('afterShowContent', function () {

						//Get Product Information
						var productinfo = pdp.getItemInfo() ? pdp.getItemInfo() : [];

						if (!(_.isEmpty(productinfo))) {

							//Get Product Stock Information
							var stockInfo = pdp.getStockInfo();
							var isInStock = stockInfo.isInStock;
							var priceInfo = pdp.getPrice().price;

							//Set Availability Attribute for Schema of Backorder items
							pdp.modifyViewJsonLd('ProductDetails.Full.View', function (json) {

								//If Item Not In Stock and For Backorder
								if (!isInStock) {
									json = _.extend(json, {
										offers: _.extend(json['offers'], {
											availability: "https://schema.org/BackOrder"
										})
									});
								}

								if (priceInfo) {
									json = _.extend(json, {
										offers: _.extend(json['offers'], {
											price: priceInfo
										})
									});
								}

								//Enable JSON Data Logs
								if (enableJSONLogs) {
									console.log('JSON Schema Data Logs', { instock: isInStock, json: json });
								}

								return jQuery.Deferred().resolve(json);
							});

						}


					});


				}

			}
		};
	});
